import * as actionTypes from "../actions/actionTypes";

import { updateObject } from "../../shared/utility";


const initialState = {
    arrayOfIds:[]
}


const addUserIdForEditAndDel = (state, action) => {
    return updateObject(state, { arrayOfIds:[...state.arrayOfIds,action.payload.newId] })
}

const deleteUserIdForEditAndDel=(state,action)=>{
    return updateObject(state, { arrayOfIds:action.payload.arrayOfIds })
}


const OfelUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_USER_IDS_FOR_EDIT_AND_DELETE:
            return addUserIdForEditAndDel(state, action);
        case actionTypes.DELETE_USER_IDS_FOR_EDIT_AND_DELETE:
                return deleteUserIdForEditAndDel(state, action);
       
        default:
            return state
    }
}

export default OfelUserReducer;
